import React from 'react';
import Footer from "../../Components/Footer/Footer";

const PrivacyPolicy = () => {
    return (
        <div className="bg-white min-h-screen">
            {/* Header */}
            <header className="bg-gray-800 text-white py-8">
                <div className="max-w-4xl mx-auto px-4 text-center">
                    <h1 className="text-3xl font-bold">Privacy Policy</h1>
                    <p className="text-gray-300 text-sm mt-2">Last updated: August 18, 2026</p>
                </div>
            </header>

            {/* Content */}
            <main className="max-w-4xl mx-auto px-4 py-8">
                {/* Introduction */}
                <section className="mb-8">
                    <p className="text-gray-700 leading-relaxed">
                        Welcome to Windify — Bootstrap to Tailwind Converter ("we", "us", "our"). Your privacy is important to us, and this policy explains how we collect, use, and protect information when you use bootstrap-to-tailwind-css.vercel.app (the "Site").
                    </p>
                </section>

                {/* Information Collection */}
                <section className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">Information We Collect</h2>
                    <p className="text-gray-700 leading-relaxed">
                        The code you paste into the converter is processed entirely in your browser — it is never uploaded to or stored on our servers. We collect basic information such as your email address only if you contact us directly. We also gather non-personal data like your approximate location, device/browser type, and browsing behavior through analytics and advertising cookies, described below.
                    </p>
                </section>

                {/* Use of Information */}
                <section className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">How We Use Your Information</h2>
                    <p className="text-gray-700 leading-relaxed">
                        Information collected is used to operate and improve the converter, respond to inquiries, understand how visitors use the Site, and — where applicable — serve relevant advertising. We do not sell your personal data.
                    </p>
                </section>

                {/* Cookies & Advertising */}
                <section className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">Cookies, Analytics &amp; Advertising</h2>
                    <p className="text-gray-700 leading-relaxed mb-3">
                        We use Google Analytics to understand how visitors use this Site, using cookies and similar technologies.
                    </p>
                    <p className="text-gray-700 leading-relaxed mb-3">
                        We may also use Google AdSense to display advertising on this Site. Google, as a third-party vendor, uses cookies (including the DoubleClick DART cookie) to serve ads based on your prior visits to this Site and other sites on the Internet. Google's use of advertising cookies enables it and its partners to serve ads based on your visits to this and/or other sites.
                    </p>
                    <p className="text-gray-700 leading-relaxed mb-3">
                        You may opt out of personalized advertising by visiting{' '}
                        <a href="https://adssettings.google.com/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                            Google Ads Settings
                        </a>. You can also learn more about how Google uses information from sites that use its services at{' '}
                        <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                            policies.google.com/technologies/partner-sites
                        </a>.
                    </p>
                    <p className="text-gray-700 leading-relaxed">
                        You can control or delete cookies at any time through your browser settings. Disabling cookies may affect some functionality of the Site.
                    </p>
                </section>

                {/* Children's Privacy */}
                <section className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">Children's Privacy</h2>
                    <p className="text-gray-700 leading-relaxed">
                        This Site is not directed at children under 13, and we do not knowingly collect personal information from children under 13.
                    </p>
                </section>

                {/* Changes */}
                <section className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">Changes to This Policy</h2>
                    <p className="text-gray-700 leading-relaxed">
                        We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated "Last updated" date.
                    </p>
                </section>

                {/* Contact Information */}
                <section>
                    <h2 className="text-xl font-semibold mb-4">Contact Us</h2>
                    <p className="text-gray-700 leading-relaxed">
                        For any questions about this Privacy Policy, reach out to us at <a href="mailto:shahzaibkesrani3@gmail.com" className="text-blue-600 hover:underline">shahzaibkesrani3@gmail.com</a>.
                    </p>
                </section>
            </main>
            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
